import { controls, ll } from "../../../framework";
import { userHasRight } from "../../../framework";
import K_Checkbox from "../templates/K_Checkbox";
import { ComponentOptions, RightLockable } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface CheckboxOptions extends ComponentOptions {
    label?: string;
    required?: boolean | "true";
    labelAbove?: string;
    countBind?: string;
    bindClasses?: string;
    bindClass?: string;
    bsc?: string;
    valueWidth?: number;
    readonly?: boolean;
    readOnly?: boolean;
    title?: string;
    dataTextField?: string;
    dataValueField?: string;
    textField?: string;
    valueField?: string;
    checkboxClasses?: string;
    containerClasses?: string;
    toolTip?: string;
    tooltipContent?: any;
    tooltipAlignRight?: boolean;
    labelClasses?: string;
    requiredRight?: string;
    isPaneField?: boolean;
}

export class Checkbox extends TemplateComponent {

    options: CheckboxOptions & RightLockable;

    constructor(options: CheckboxOptions) {
        super(K_Checkbox, options);
    }

    preRender() {
        const options = this.options;

        options.title = options.label;
        options.dataTextField = options.textField;
        options.dataValueField = options.valueField;
        options.containerClasses = options.isPaneField ?
            options.containerClasses || "pane-field col-lg-3 col-md-4 col-xs-6 h-35" :
            `checkbox ${options.containerClasses}`;

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = true;
                options.readonly = true;
                options.readOnly = true;
                options.checkboxClasses += " right-locked";
                options.containerClasses += " right-locked";
            }
        }
    }

    /*
    * create
    * Wrapper for kendo template for Checkbox Control
    *
    * data.id - Id for checkbox
    * data.label - Title for checkbox
    * data.toolTip - Checkbox tooltip text
    * data.bind - Value to bind to
    * data.classes - Extra Classnames needed
    *
    */
    create() {
        var checkbox = $("#" + this.options.id);
        var bindValue = this.options.bindValue;

        checkbox.on("zCheckboxBind", function (e) {
            var observable = checkbox.data("bindData");
            var bind = checkbox.data("bind").slice(9); // remove 'checked: '

            var observableBindValue = observable[bind];

            if (observableBindValue) {
                if (observableBindValue === "False") {
                    observable[bind] = false;
                } else if (observableBindValue === "True") {
                    observable[bind] = true;
                }
            } else if (observableBindValue === null) { // make sure we only set null, not undefined
                observable[bind] = false;
            }

        });

        checkbox.tie("change", function (e) {
            var observable = checkbox.data("bindData");
            var checked = checkbox.prop("checked");

            if (!checked && observable) {
                observable.set(bindValue, "false");
                observable.set(bindValue, false);
            }
        });

        if (this.options.toolTip || this.options.tooltipContent) {
            if (this.options.tooltipAlignRight) {
                controls.toolTip({
                    alignX: "right",
                    alignY: "center",
                    alignTo: "target",
                    offsetY: 0,
                    offsetX: 10,
                    selector: $(`#${this.options.id}_cid`),
                    content: this.options.toolTip ? ll(this.options.toolTip) : this.options.tooltipContent
                });
            } else {
                controls.toolTip({
                    alignX: "center",
                    alignY: "top",
                    alignTo: "target",
                    offsetY: 5,
                    selector: $(`#${this.options.id}_cid`),
                    content: this.options.toolTip ? ll(this.options.toolTip) : this.options.tooltipContent
                });
            }
        }
    }

}
